import React, { useRef, useCallback } from 'react';
import { connect } from 'react-redux';
import PackageDetails from './PackageDetails';
// import MobileTab from './MobileTab';
import BestSellingSection from './BestSellingSection';
import FAQSection from './FAQ';
import FAQV2Section from './FAQ_V2';
import PackageTabSection from './PackageTabSection';
import FiltersMbSection from './FiltersMbSection';
import { getMMT_HLD_OBJ } from '../../../../../common/utils/appUtils';
import {
  getPackagesAction,
  pageLoadingAction,
} from '../../../../redux/actions/listingPackagesActions';
import { isAgentLoggedIn } from '../../../../../common/utils/browserUtils';
import InfoStrip from '../../../../../common/component/InfoStrip';
import AboutPackages from './PackageDetails/AboutPackages';
import BreadCrum from '../BreadCrum';
import ChatApp from '../../../../../common/component/HolidaysExpertChat';
import CruiseWrapper from '../../../../../cruise/CruiseWrapper';

const HolidayRHS = ({
  filterTabActive,
  handleFilterTab,
  groupList,
  groupMetaIsLoading,
  getPackagesAction,
  handleFilterChange,
  handleClearAllFilters,
  activeTab,
  handleTabSelect,
  groupPackagesMap,
  faqHTML,
  blockerNotificationsCount = 0,
  pageLoadingAction,
  cruiseData,
  loadEventTriggered,
}) => {
  const { fromSEO, holidaysExpertChat } = getMMT_HLD_OBJ();
  const tabScrollRef = useRef(null);

  const scrollToRight = () => {
    const container = tabScrollRef.current;
    container.scrollTo({
      left: container.scrollLeft + 150, // Adjust the scroll distance as needed
      behavior: 'smooth',
    });
  };

  const loadMorePackages = useCallback(
    ({ group, offset }) => {
      getPackagesAction({ groupId: group?.id, offset });
    },
    [getPackagesAction]
  );

  const disablePackageClick = isAgentLoggedIn() && blockerNotificationsCount > 0;

  return (
    <div className="holidayRhs">
      {holidaysExpertChat && isAgentLoggedIn() && <ChatApp />}
      <FiltersMbSection filterTabActive={filterTabActive} handleFilterTab={handleFilterTab} />
      {!cruiseData && (
        <PackageTabSection
          tabs={groupList}
          handleTabSelect={handleTabSelect}
          scrollToRight={scrollToRight}
          tabScrollRef={tabScrollRef}
          activeTab={activeTab?.id ? activeTab : groupList?.[0]}
          isLoading={groupMetaIsLoading}
          groupPackagesMap={groupPackagesMap}
        />
      )}
      {disablePackageClick && !cruiseData && (
        <InfoStrip
          message="Please read the pending notifications to enable packages"
          showArrow={false}
          bgColorClass="cityChangeWarningContainer"
          type="no_pkg_found"
        />
      )}
      <div className={`packageInnerDetails ${disablePackageClick && 'disable-click'}`}>
        {/* <MobileTab/> */}
        {/**
         * activeTab || groupList?.[0] - this is required, as in case of ssr component
         * local state never runs so we need to manually pass the first group as active.
         */}
        {cruiseData ? (
          <CruiseWrapper />
        ) : (
          <PackageDetails
            activeTab={activeTab || groupList?.[0]}
            loadMorePackages={loadMorePackages}
            handleFilterChange={handleFilterChange}
            handleClearAllFilters={handleClearAllFilters}
            tabs={groupList}
            groupMetaIsLoading={groupMetaIsLoading}
            pageLoadingAction={pageLoadingAction}
            loadEventTriggered={loadEventTriggered}
          />
        )}
        {fromSEO && <BestSellingSection />}
        {fromSEO && <AboutPackages />}
        {fromSEO && (faqHTML ? <FAQV2Section /> : <FAQSection />)}
        {fromSEO && <BreadCrum />}
      </div>
    </div>
  );
};

const mapStateToProps = ({ groupMetadata, listingPackages, seo }, props) => ({
  groupList: groupMetadata?.groupDetailsList,
  groupMetaIsLoading: groupMetadata?.isLoading,
  groupPackagesMap: listingPackages?.packagesByGroupId,
  activeTab: groupMetadata?.groupDetailsList?.find(group => group?.id === props.activeTabId) || {
    id: props.activeTabId,
  },
  faqHTML: seo?.metaData?.faqHTML,
});

const mapDispatchToProps = {
  getPackagesAction,
  pageLoadingAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(HolidayRHS);
